import { applyMiddleware, createStore } from 'redux'
import reduxThunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension' // eslint-disable-line
import reducers from './reducers'
import { trackingMiddleware } from './middlewares/tracking'

const store = createStore(
  reducers,
  composeWithDevTools(
    applyMiddleware(reduxThunk, trackingMiddleware),
  ),
)

export default store
